import { connect } from 'react-redux';

import Component from '../components/js/TopHorseRacing';
import { ITopStates } from '../store';

const mapStateToProps = (state: ITopStates) => ({
  gradePickup: {
    isShow: state.horseRacing.isShow,
    races: state.horseRacing.races
  }
});

export default connect(mapStateToProps)(Component);
